'use client';

import { c as _c } from "react/compiler-runtime";
import type { MentoringDiscount } from '@algoacademy/backend/modules/payment/discount-pricing';
import type { GroupMentoringProductDTO, IndividualMentoringProductDTO, ProjectMentoringProductDTO } from '@algoacademy/backend/modules/payment/endpoints/mutations/stripe-checkout/input.dto/input.dto';
import { Button } from '@algoacademy/design-system/web/actions/Button';
import { useWaitlistSignup } from '@/app/(marketing-site)/_components/waitlist/WaitlistSignupContext';
import { regulaminSectionHref } from '@/app/(marketing-site)/regulamin/_constants/section-hrefs';
import { BuyData } from '../BuyData';

// import { ScheduleAppointmentDialog } from '../ScheduleAppointmentDialog'

type PricingCardProps = {
  mentoringProduct: GroupMentoringProductDTO | IndividualMentoringProductDTO | ProjectMentoringProductDTO;
  /** When true, shows waitlist and subscription detail actions under the price. */
  goalPage?: boolean;
  /** BuyData styling; falls back to goalPage when omitted. */
  pricingGoalPage?: boolean;
  /**
   * The discount staff is pricing on the card above. Null for every reader who
   * may not manage payments, and then the card is the public one, down to the
   * pixel.
   */
  discount?: MentoringDiscount | null;
};
export function PricingCard(t0) {
  const $ = _c(11);
  const {
    mentoringProduct,
    goalPage: t1,
    pricingGoalPage,
    discount: t2
  } = t0;
  const goalPage = t1 === undefined ? false : t1;
  const discount = t2 === undefined ? null : t2;
  const {
    open
  } = useWaitlistSignup();
  const buyDataGoalPage = pricingGoalPage ?? goalPage;
  let t3;
  if ($[0] !== buyDataGoalPage || $[1] !== discount || $[2] !== mentoringProduct) {
    t3 = <BuyData mentoringProduct={mentoringProduct} goalPage={buyDataGoalPage} discount={discount} />;
    $[0] = buyDataGoalPage;
    $[1] = discount;
    $[2] = mentoringProduct;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== goalPage || $[5] !== mentoringProduct || $[6] !== open) {
    t4 = goalPage ? <div className="flex w-full flex-col items-center gap-3"><Button size="xl" className="w-full" onClick={() => open(mentoringProduct.name)}>Zapisz się na listę oczekujących</Button><Button plain={true} size="xl" className="w-full" href={regulaminSectionHref("paymentRules")}>Szczegóły subskrypcji</Button></div> : null;
    $[4] = goalPage;
    $[5] = mentoringProduct;
    $[6] = open;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}